import { PREFIX, URIType } from "../uri";

export class PhysicalArtefactURI {
  type: URIType.PhysicalArtefact = URIType.PhysicalArtefact;
  patientId: string;
  physicalArtefactId: string;
  physicalArtefactVersion: string;

  static parse(text: string) {
    const parts = text.split(":");

    if (parts.length !== 6 || parts[3] !== "physical-artefact") {
      return null;
    }

    const [, , patientId, , physicalArtefactId, physicalArtefactIdVersion] =
      parts.map(decodeURIComponent);
    return new PhysicalArtefactURI(
      patientId,
      physicalArtefactId,
      physicalArtefactIdVersion
    );
  }

  static fromString(text: string) {
    const uri = PhysicalArtefactURI.parse(text);
    if (!uri) {
      throw new Error("Not a PhysicalArtefactURI");
    }
    return uri;
  }

  constructor(
    patientId: string,
    physicalArtefactId: string,
    physicalArtefactIdVersion: string = "latest"
  ) {
    this.patientId = patientId;
    this.physicalArtefactId = physicalArtefactId;
    this.physicalArtefactVersion = physicalArtefactIdVersion;
  }

  toString(): string {
    return [
      PREFIX,
      "patient",
      this.patientId,
      "physical-artefact",
      this.physicalArtefactId,
      this.physicalArtefactVersion,
    ]
      .map(encodeURIComponent)
      .join(":");
  }
}
